import { useMemo } from 'react';

/**
 * Application Configuration Hook
 * Provides easy access to platform configuration with sensible defaults
 * Note: Platform config moved to AWS Parameter Store, using defaults here
 */
export interface AppConfig {
  // Company branding
  companyName: string;
  platformName: string;
  logoUrl: string;
  
  // Localization
  timezone: string;
  defaultLanguage: string;
  dateFormat: string;
  timeFormat: string;
  currency: string;
  
  // Display settings
  paginationSize: number;
  
  // Helpers
  is24HourTime: boolean;
}

/**
 * Hook to access application configuration
 * Returns configuration with fallback defaults (platform config moved to AWS Parameter Store)
 */
export function useAppConfig(): AppConfig {
  return useMemo(() => {
    return {
      // Company branding (defaults - actual values in AWS Parameter Store)
      companyName: 'Cnapse',
      platformName: 'Cnapse Cleanroom Intelligence (CCI)',
      logoUrl: '',
      
      // Localization (defaults)
      timezone: 'UTC',
      defaultLanguage: 'en',
      dateFormat: 'MM/DD/YYYY',
      timeFormat: '12h',
      currency: 'USD',
      
      // Display settings
      paginationSize: 25,
      
      // Computed helpers
      is24HourTime: false,
    };
  }, []);
}

/**
 * Hook to access just the pagination size
 * Useful for table components
 */
export function usePaginationSize(): number {
  const config = useAppConfig();
  return config.paginationSize;
}
